<template>
  <v-card>
    <v-card-title>
      Welcome to Atlas!

      <v-spacer />

      <v-progress-circular
        :value="(items.filter(i => i.done).length / items.length) * 100"
        :rotate="-90"
        :width="2"
        color="accent"
      />
    </v-card-title>

    <v-card-text>
      Hey {{ $currentUser.profile.displayName }}
      here a few things to do for getting started with Atlas!
    </v-card-text>

    <v-list>
      <v-list-item
        v-for="item in items"
        :key="item.name"
        :to="item.to"
      >
        <v-list-item-avatar
          :color="item.done ? 'primary' : 'grey'"
        >
          <v-icon v-if="item.done">
            check
          </v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title
            :style="{ textDecoration: item.done ? 'line-through' : 'none' }"
            v-text="item.name"
          />
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style>

</style>
